import { fontSizeParagraph, lineHeightGlobal, bottomMarginItemGlobal } from "../../utils/pdfConstants";

const KL_COLORS = {
  KL1: "#ba3b46",
  KL2: "#ba3b46",
  KL3: "#d0c407",
  KL4: "#04aa00",
  KL5: "#04aa00",
};

const KL_TEXT = {
  KL1: "heikko",
  KL2: "välttävä",
  KL3: "tyydyttävä",
  KL4: "hyvä",
  KL5: "erinomainen",
};

export function renderKuntoarviolauseBlock({ data, content }) {
  const { subject = "", kl = "KL3" } = data || {};
  const klText = KL_TEXT[kl] || "tyydyttävä";
  const color = KL_COLORS[kl] || "#333";

  content.push({
    text: [
      { text: "Kokonaisuutena ", font: "Lato", fontSize: fontSizeParagraph },
      { text: subject, font: "Lato", fontSize: fontSizeParagraph },
      { text: " kunto on ", font: "Lato", fontSize: fontSizeParagraph },
      { text: klText, font: "Lato", fontSize: fontSizeParagraph },
      { text: ". ", font: "Lato", fontSize: fontSizeParagraph },
      { text: kl, font: "Lato", fontSize: fontSizeParagraph, bold: true, color },
    ],
    lineHeight: lineHeightGlobal,
    margin: [0, 0, 0, bottomMarginItemGlobal],
  });
}
